import { Box, Grid, Paper, Snackbar, Table, TableBody, TableContainer, TableHead, TablePagination, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from '../../../styles.module.css';
import { useDispatch, useSelector } from "react-redux";
// import { editDeleteCharges, getChargesList } from "../../../../../actions/actions";
import { ActionMsg, AddButton, Breadcrumb, CustomePopover, DateConversionOnEntryPage, DeleteDialog, ExcelDownload, HandleCloseSnackbar, HandleSort, SearchInput, StyledTableCell, StyledTableRow, useMessageHandler } from "../../reusableComponent/Reusables";
import { rows } from './../MastersFakeDb';
import { editDeleteRM, getRMList } from "../../../actions/actions";
import HeaderSection from "../../reusableComponent/HeaderSection";
import rmMasterService from "../../../services/masters/rmMaster.Service"
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import CustomPagination from "../../reusableComponent/CustomPagination";

const RMList = () => {
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;

    const [isDelete, setIsDelete] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState();
    const [sortBy, setSortBy] = useState(null);
    const totalCount = useSelector(state => state.rm.total_count || 0);
    const defaultRowsPerPage = useSelector(state => state.rm.rows_per_page || 15);
    // const rows = useSelector(state => state.rm.rm)
    const [rows, setRows] = useState([]);
    const [searchKey, setSearchKey] = useState('');

    // const addSerialNumbers = (data) => {
    //     return data.map((item, index) => ({
    //         ...item,
    //         id: index + 1 
    //     }));
    // };
    // const rowsWithSerialNumbers = addSerialNumbers(rows);

    const fields = ['id', "rm_code", "rm_name"];
    const labels = ['Id', "rm_code", "rm_name"];

    // const [successMessage, setSuccessMessage] = useState(null);
    // const respMsgState = 'test'
    // const respMsgState = useSelector((state) => state.rm.message);
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
    const [controller, setController] = useState({
        page: 0,
        rowsPerPage: defaultRowsPerPage
    });
    useEffect(() => {
        setController(prev => ({
            ...prev,
            rowsPerPage: defaultRowsPerPage,
            page: 0,
        }));
    }, [defaultRowsPerPage]);


    const handleChangePage = (event, newPage) => {
        setController({
            ...controller,
            page: newPage
        });
    };

    const handleChangeRowsPerPage = (event) => {
        setController({
            ...controller,
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        });
    };

       const fetchData = async () => {
           try {
           const params = {
             page: controller.page,
             size: controller.rowsPerPage,
             searchKey: searchKey,
           };
           const response = await rmMasterService.getRMList (params);
               setRows(response);
             } catch (error) {
               setSuccessMessage("Error fetching data");
             }
           };

    // const handleSearch = (e) => {
    //     setSearchKey(e.target.value)
    //     const params = {
    //         page: controller.page,
    //         size: e.target.value === '' ? controller.rowsPerPage : (rows[0]?.total_count || 0),
    //         searchKey: e.target.value,
    //     }
    //     dispatch(getRMList(params))
    // }
    const handleSearch = async (e) => {
        const searchValue = e.target.value;
        setSearchKey(searchValue);  // Set the search key
        
        // Prepare the params based on the search value
        const params = {
            page: controller.page,
            size: searchValue === '' ? controller.rowsPerPage : (rows[0]?.total_count || 0),
            searchKey: searchValue,
        };
    
        try {
            // Fetch data using the fetchData function (assuming fetchData is already declared)
            await fetchData(params);
        } catch (error) {
            console.error("Error in handleSearch:", error);
        }
    };

    useEffect(() => {
        fetchData()
    }, [controller]);

    // const { shouldShowMsg, responseMessage } = useMessageHandler( null, setSuccessMessage, respMsgState);

    // useEffect(() => {
    // }, [shouldShowMsg, responseMessage,]);

    const deleteRecord = async (id) => {
            try {
                 await rmMasterService.editDeleteRM ({
                    rm_id: id,
                   changedUpdatedValue: "delete"
                 });
                 setIsDelete(false);
                 fetchData();
                 setSuccessMessage("Record deleted successfully");
               } catch (error) {
                 setSuccessMessage("Error deleting record");
               }
             };

    const handleDelete = (functions) => {
        setIsDelete(true);
        setDeleteInfo(functions);
    }

    const handleClose = (event, reason) => {
        setIsDelete(false)
        setDeleteInfo(null);
    };

    const [successMessage, setSuccessMessage] = useState(null);
    //const respMsgState = 'test'
    // const respMsgState = useSelector((state) => state.rm.message);

    // const { shouldShowMsg, responseMessage } = useMessageHandler(fetchData, null, setSuccessMessage, respMsgState);
    // useEffect(() => {
    //     if (respMsgState) {
    //         setSuccessMessage(respMsgState);
    //     }
    // }, [respMsgState]);
    // useEffect(() => {
    // }, [shouldShowMsg, responseMessage,]);





    // Sort rows by entry_date descending
    const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
    // Calculate pagination info
    const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;


    console.log('Pagination Info:', { startRecord, endRecord, totalCount, effectiveTotalCount, paginationInfo });





    return (
        <Box className={`${styles.cts_page}`} sx={{ padding: "0px !important", margin: "0px !important" }}>
            <Box className={`${styles.body}`}>
                <Breadcrumb
                    routeSegments={[
                        // { name: 'Dashbord', path: '/dashboard' },
                        { name: 'RM List' },
                    ]}
                />




                <HeaderSection
                    title="RM LIST
"
                    addNewPath="/masters/add-rm"
                    searchKey={searchKey}
                    handleSearch={handleSearch}
                    sortedRows={sortedRows}
                    fields={fields}
                    labels={labels}
                    filename="RM List"
                    paginationInfo={paginationInfo}
                    controller={controller}
                    handleChangePage={handleChangePage}
                />



                <Paper sx={{ width: '100%',  }}>
                    <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => HandleSort('rm_code', sortBy, setSortBy, rows)}>RM Code<span className={`${styles.sort_icon}`}> {sortBy === 'rm_code' ? '▲' : '▼'} </span></StyledTableCell>
                                    <StyledTableCell sx={{ width: '20%'}} align="left" className={`${styles.table_head}`} onClick={() => HandleSort('rm_name', sortBy, setSortBy, rows)}>RM Name<span className={`${styles.sort_icon}`}> {sortBy === 'rm_name' ? '▲' : '▼'} </span></StyledTableCell>
                                    <StyledTableCell sx={{ width: '20%' }} align="left" className={`${styles.table_head}`} onClick={() => HandleSort('uom_consumption', sortBy, setSortBy, rows)}>UOM Consumption<span className={`${styles.sort_icon}`}> {sortBy === 'uom_consumption' ? '▲' : '▼'} </span></StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => HandleSort('uom_purchase', sortBy, setSortBy, rows)}>UOM Purchase<span className={`${styles.sort_icon}`}> {sortBy === 'uom_purchase' ? '▲' : '▼'} </span></StyledTableCell>
                                    {/* <StyledTableCell align="center" className={`${styles.table_head}`} onClick={() => HandleSort('rate', sortBy, setSortBy, rows)}>Rate<span className={`${styles.sort_icon}`}> {sortBy === 'rate' ? '▲' : '▼'} </span></StyledTableCell> */}
                                    {/* <StyledTableCell align="center" className={`${styles.table_head}`} onClick={() => HandleSort('opening_bal', sortBy, setSortBy, rows)}>Opening Balance<span className={`${styles.sort_icon}`}> {sortBy === 'opening_bal' ? '▲' : '▼'} </span></StyledTableCell> */}
                                    {/* <StyledTableCell align="center" className={`${styles.table_head}`} onClick={() => HandleSort('min_bal', sortBy, setSortBy, rows)}>Min Balance<span className={`${styles.sort_icon}`}> {sortBy === 'min_bal' ? '▲' : '▼'} </span></StyledTableCell> */}
                                    {/* <StyledTableCell align="center" className={`${styles.table_head}`} onClick={() => HandleSort('max_bal', sortBy, setSortBy, rows)}>Max Balance<span className={`${styles.sort_icon}`}> {sortBy === 'max_bal' ? '▲' : '▼'} </span></StyledTableCell> */}
                                    <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => HandleSort('bin_no', sortBy, setSortBy, rows)}>Bin No<span className={`${styles.sort_icon}`}> {sortBy === 'bin_no' ? '▲' : '▼'} </span></StyledTableCell>
                                    <StyledTableCell align="center" className={`${styles.table_head}`}>Action</StyledTableCell>

                                </StyledTableRow>
                            </TableHead>
                            <TableBody sx={{ backgroundColor: '#fff' }}>
                                {Array.isArray(rows) && rows.map((row, index) => (
                                    <StyledTableRow
                                        key={row.name}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >

                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.rm_code}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.rm_name}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.uom_consumption}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.uom_purchase}</StyledTableCell>
                                        {/* <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.rate}</StyledTableCell> */}
                                        {/* <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.opening_bal}</StyledTableCell> */}
                                        {/* <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.min_bal}</StyledTableCell> */}
                                        {/* <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.max_bal}</StyledTableCell> */}
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.bin_no}</StyledTableCell>
                                        <StyledTableCell align="center" >
                                            <CustomePopover row={row}    handleCancel={false} handleDelete={false} linkTo="/masters/add-rm"   handlePrint ={false}/>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                                 <CustomPagination
  page={controller.page}
  rowsPerPage={controller.rowsPerPage}
  totalCount={total_count || 0}
  onPageChange={(newPage) => handleChangePage(null, newPage)}
/>
                </Paper>

                <DeleteDialog
                    open={isDelete}
                    handleClose={handleClose}
                    deleteInfo={deleteInfo}
                    deleteRecord={deleteRecord}
                    deleteID={deleteInfo?.rm_id || null}
                    displayName={deleteInfo?.rm_id || ''}
                />
                <ReusableSnackbar
                    open={!!successMessage}
                    onClose={(event, reason) => {
                        if (reason !== 'clickaway') {
                            setSuccessMessage("");
                        }
                    }}
                    message={successMessage}
                    autoHideDuration={2000}
                    vertical="top"
                    horizontal="right"
                />
            </Box>
        </Box>
    )
}
export default RMList;